import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import StaticPageLayout from '@/Layout/StaticPageLayout';
import PageMeta from '@/shared/components/PageMeta';

import { startHandoff } from './handoff';
import styles from './index.module.scss';

type Props = { readonly handoffUrl?: string };

const AuthorizationComplete = ({ handoffUrl }: Props) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (handoffUrl) {
      startHandoff(handoffUrl);
    }
  }, [handoffUrl]);

  return (
    <StaticPageLayout>
      <PageMeta titleKey="description.authorization_submitted" />
      <div className={styles.content}>
        <h1>{t('description.authorization_submitted')}</h1>
        <p>{t('description.authorization_handoff')}</p>
      </div>
    </StaticPageLayout>
  );
};

export default AuthorizationComplete;
